module.exports = __webpack_public_path__ + "static/media/client22.dd8357de.jpeg";